module.exports = __webpack_public_path__ + "static/media/ds03.ed84880c.jpg";